import React, { useState } from "react";
import { func_validation, func_datetime } from "functions";

function ReferenceCell({ value }) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!value || (typeof value === 'object' && Object.keys(value).length === 0)) {
    return <div className="noWrap-text-ellipsis">-</div>;
  }

  const referenceCount = Object.keys(value).length;
  
  return (
    <div style={{ minWidth: '200px' }}>
      <div 
        style={{ 
          color: '#007bff', 
          cursor: 'pointer', 
          fontWeight: '500',
          marginBottom: isExpanded ? '8px' : '0'
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span style={{ marginRight: '6px' }}>
          {isExpanded ? '▼' : '▶'}
        </span>
        {referenceCount} outlet{referenceCount !== 1 ? 's' : ''}
      </div>
      
      {isExpanded && (
        <div style={{ 
          marginTop: '8px', 
          paddingLeft: '20px',
          maxHeight: '300px',
          overflowY: 'auto',
          fontSize: '0.9em'
        }}>
          <table style={{ width: '100%', fontSize: '0.95em' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                <th style={{ padding: '4px 8px', textAlign: 'left', fontWeight: '600' }}>Outlet</th>
                <th style={{ padding: '4px 8px', textAlign: 'right', fontWeight: '600' }}>Count</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(value).map(([outlet, count], index) => (
                <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '4px 8px' }}>{outlet}</td>
                  <td style={{ padding: '4px 8px', textAlign: 'right' }}>{count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export function useTableColumns(productCode, companyId) {
  const isLoyaltyLite = productCode === "Loyalty Lite";
  const isLiveOrder = productCode === "XLO001";
  const isCompanyIdFiltered = companyId !== null && companyId !== undefined && companyId !== "";

  function getColumn_companyId() {
    return {
      Header: "Company ID",
      accessor: "CompanyId",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_locationId() {
    return {
      Header: "Location ID",
      accessor: "LocationId",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_locationName() {
    return {
      Header: "Location Name",
      accessor: "LocationName",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_productCode() {
    return {
      Header: "Product Code",
      accessor: "ProductCode",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_goLive() {
    return {
      Header: "Go Live",
      accessor: "GoLive",
      Cell: (props) => {
        let value = props?.cell?.value;
        let formatted = value ? "Live" : "Not Live";
        return <div className="noWrap-text-ellipsis">{formatted}</div>;
      },
    };
  }

  function getColumn_activationDate() {
    return {
      Header: "Activation Date",
      accessor: "ActivationDate",
      Cell: (props) => {
        let value = props?.cell?.value;
        let formatted = "-";
        if (func_validation.isStringTrimNotEmpty(value)) {
          formatted = func_datetime.convertDateTimeToLocal(value, "DD/MM/YYYY HH:mm");
        }
        return <div className="noWrap-text-ellipsis">{formatted}</div>;
      },
    };
  }

  function getColumn_deactivationDate() {
    return {
      Header: "Deactivation Date",
      accessor: "DeactivationDate",
      Cell: (props) => {
        let value = props?.cell?.value;
        let formatted = "-";
        if (func_validation.isStringTrimNotEmpty(value)) {
          formatted = func_datetime.convertDateTimeToLocal(value, "DD/MM/YYYY HH:mm");
        }
        return <div className="noWrap-text-ellipsis">{formatted}</div>;
      },
    };
  }

  function getColumn_liveOrderTransactionCount() {
    return {
      Header: "Live Order Count",
      accessor: "LiveOrderTransactionCount",
      Cell: (props) => {
        let value = props?.cell?.value;
        let formatted = "-";
        if (func_validation.isNumberValid(value)) {
          formatted = value.toLocaleString();
        }
        return <div className="noWrap-text-ellipsis">{formatted}</div>;
      },
    };
  }

  function getColumn_activatorCode() {
    return {
      Header: "Activator Code",
      accessor: "ActivatorCode",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_activatorName() {
    return {
      Header: "Activator Name",
      accessor: "ActivatorName",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <div className="noWrap-text-ellipsis">{value || "-"}</div>;
      },
    };
  }

  function getColumn_totalActiveOutlet() {
    return {
      Header: "Total Active Outlet",
      accessor: "TotalActiveOutlet",
      Cell: (props) => {
        let value = props?.cell?.value;
        let formatted = "-";
        if (func_validation.isNumberValid(value)) {
          formatted = value.toLocaleString();
        }
        return <div className="noWrap-text-ellipsis">{formatted}</div>;
      },
    };
  }

  function getColumn_reference() {
    return {
      Header: "Reference",
      accessor: "Reference",
      Cell: (props) => {
        let value = props?.cell?.value;
        return <ReferenceCell value={value} />;
      },
    };
  }

 // Build columns array based on product code
  let columns = [getColumn_companyId()];

  // Add Location ID for all except Loyalty Lite
  if (!isLoyaltyLite) {
    columns.push(getColumn_locationId());
  }

  columns.push(
    getColumn_productCode(),
    getColumn_goLive(),
    getColumn_activationDate(),
    getColumn_deactivationDate()
  );

  // Add Live Order Count for all except Loyalty Lite
  // if (!isLoyaltyLite) {
  //   columns.push(getColumn_liveOrderTransactionCount());
  // }

  // Add Activator Code and Name for all except Live Order (XLO001)
  if (!isLiveOrder) {
    columns.push(getColumn_activatorCode(), getColumn_activatorName());
  }

  // Add TotalActiveOutlet and Reference when Company ID is filtered and product is Loyalty Lite
  if (isCompanyIdFiltered && isLoyaltyLite) {
    columns.push(getColumn_totalActiveOutlet(), getColumn_reference());
  }
  if (isCompanyIdFiltered && isLiveOrder) {
    columns.push(getColumn_locationName(), getColumn_liveOrderTransactionCount());
  }

  return columns;
}